import "@mantine/carousel/styles.css";
import "./PacksStrip.css";
import { Carousel } from "@mantine/carousel";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context/AppState/AppContext";
import { calculatePrice } from "../../../utils/calculatePrice";
import { formattedPrice } from "../../../utils/formatted-price";
import { currencyFormat } from "../../../utils/currencyFormat";

// Franja compacta "Ahorrá con packs" arriba de la oferta académica.
// Cada tarjeta lleva a la página del pack.
const PacksStrip = ({ packs = [] }) => {
    const navigate = useNavigate();
    const { isUSD, officialUSDValue } = useAppContext();

    if (!packs.length) return null;

    return (
        <section className="packsStrip">
            <div className="packsStrip__heading">
                <h2 className="packsStrip__title">Ahorrá con packs</h2>
                <span className="packsStrip__subtitle">Cursos completos que se compran juntos, a un precio menor</span>
            </div>
            <Carousel
                slideSize={{ base: "88%", sm: "50%", lg: "33.333%" }}
                slideGap="md"
                align="start"
                containScroll="trimSnaps"
                withControls={packs.length > 1}
                withIndicators={false}
                controlsOffset={-12}
                controlSize={32}
                classNames={{ control: "packsStrip__control", viewport: "packsStrip__viewport" }}
            >
                {packs.map(pack => {
                    const info = pack.comercialInformation || {};
                    const coursesCount = (pack.academicUnits || []).length;
                    const price = calculatePrice(info.price, officialUSDValue, isUSD, pack.type);
                    const separately = pack.priceComparison?.separately
                        ? calculatePrice(pack.priceComparison.separately, officialUSDValue, isUSD, pack.type)
                        : 0;
                    const savings = Math.max(separately - price, 0);

                    return (
                        <Carousel.Slide key={pack._id}>
                            <button type="button" className="packsStrip__card" onClick={() => navigate(`/packs/${pack._id}`)}>
                                {info.image && <img className="packsStrip__image" src={info.image} alt={info.name} />}
                                <div className="packsStrip__body">
                                    <span className="packsStrip__badge">PACK · {coursesCount} cursos</span>
                                    <span className="packsStrip__name" title={info.name}>{info.name?.toLowerCase()}</span>
                                    <span className="packsStrip__price">
                                        {formattedPrice(currencyFormat(price), isUSD)}
                                        {savings > 0 && <span className="packsStrip__savings">Ahorrás {formattedPrice(currencyFormat(savings), isUSD)}</span>}
                                    </span>
                                </div>
                            </button>
                        </Carousel.Slide>
                    );
                })}
            </Carousel>
        </section>
    );
};

export default PacksStrip;
